// extracted by mini-css-extract-plugin
export var attachment = "_r1-a";
export var emailContainer = "_r1-4";
export var emailContentPaddedContainer = "_r1-b";
export var emailHeader = "_r1-6";
export var emailIframe = "_r1-3";
export var emailInfoIcon = "_r1-9";
export var emailShortenedSummary = "_r1-e";
export var infoDropdown = "_r1-0";
export var infoRowBoundedContent = "_r1-d";
export var internal = "_r1-5";
export var merchant = "_r1-8";
export var messageInputContainer = "_r1-h";
export var normal = "_r1-7";
export var replyCard = "_r1-f";
export var subtleButton = "_r1-1";
export var subtleButtonIconContainer = "_r1-2";
export var toggleViewRepliesButton = "_r1-c";
export var wrappingText = "_r1-g";